module.exports = __webpack_public_path__ + "bin/img/favicon_mini.2db50bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/favicon_mini.png
// module id = T3vM
// module chunks = 1